import React from 'react';
import {
  Box,
  Container,
  Typography,
  Grid,
  IconButton,
  Divider,
  useTheme,
  useMediaQuery,
} from '@mui/material';
import { Link } from 'react-router-dom';
import {
  Phone,
  Email,
  LocationOn,
  Facebook,
  Instagram,
  Twitter,
  YouTube,
} from '@mui/icons-material';

const Footer = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const navigationLinks = [
    { text: 'Home', path: '/' },
    { text: 'About', path: '/about' },
    { text: 'Gallery', path: '/gallery' },
    { text: 'Contact', path: '/contact' },
  ];

  const socialLinks = [
    { icon: <Facebook />, href: 'https://www.facebook.com/share/1FQGAi9W6g/', label: 'Facebook' },
    { icon: <Instagram />, href: 'https://www.instagram.com/cashewcounty?igsh=bG5kcHJvbjhycTBj', label: 'Instagram' },
    // { icon: <Twitter />, href: '#', label: 'Twitter' },
    // { icon: <YouTube />, href: '#', label: 'YouTube' },
  ];

  return (
    <Box sx={{ backgroundColor: 'primary.dark', color: 'white', py: 6 }} id="contact">
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          {/* Welcome Section */}
          <Grid item xs={12} md={4}>
            <Typography
              variant="h4"
              component="h3"
              gutterBottom
              sx={{ fontWeight: 700, mb: 2 }}
            >
              Welcome to Cashew County
            </Typography>
            <Typography
              variant="body1"
              sx={{ mb: 3, lineHeight: 1.8, opacity: 0.9 }}
            >
              Cashew County offers premium <strong>NA (Non-Agricultural) plots in Guhagar</strong>, perfectly situated in the scenic beauty of the Konkan coast. Whether you're planning to build your dream vacation home or simply looking to make a future-focused investment, these legally clear, well-planned plots offer the perfect blend of nature, security, and long-term value.
            </Typography>
            <Typography
              variant="body1"
              sx={{ lineHeight: 1.8, opacity: 0.9 }}
            >
              Surrounded by lush greenery, whispering palms, and the serene rhythm of the Arabian Sea, our plots offer more than just land — they offer a <strong>lifestyle that’s peaceful, purposeful, and promising.</strong>
            </Typography>
          </Grid>

          {/* Navigation */}
          <Grid item xs={12} md={4}>
            <Typography
              variant="h6"
              component="h4"
              gutterBottom
              sx={{ fontWeight: 600, mb: 3 }}
            >
              NAVIGATION
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              {navigationLinks.map((link) => (
                <Link
                  key={link.text}
                  to={link.path}
                  style={
                    {
                      textDecoration: 'none',
                      color: 'white',
                      opacity: 0.9,
                    }
                  }
                  onMouseEnter={(e) => {
                    e.target.style.opacity = 1;
                    e.target.style.textDecoration = 'underline';
                    e.target.style.color = 'white';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.opacity = 0.9;
                    e.target.style.textDecoration = 'none';
                    e.target.style.color = 'white';
                  }}
                >
                  {link.text}
                </Link>
              ))}
            </Box>
          </Grid>

          {/* Contact */}
          <Grid item xs={12} md={4}>
            <Typography
              variant="h6"
              component="h4"
              gutterBottom
              sx={{ fontWeight: 600, mb: 3 }}
            >
              CONTACT
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                <LocationOn sx={{ color: 'primary.light' }} />
                <Typography variant="body2" sx={{ opacity: 0.9 }}>
                At Post. Palpene,Tal Guhagar Dist.Ratnagiri Maharashtra 415724
                </Typography>
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                <Email sx={{ color: 'primary.light' }} style={{ color: 'white' }} />
                <Link
                  href="mailto:cashewcounty.guhagar@gmail.com"
                  color="white"
                  sx={{
                    textDecoration: 'none',
                    color: 'white',
                    opacity: 0.9,
                    '&:hover': {
                      opacity: 1,
                      color: 'white',
                    },
                  }}
                  style={{ color: 'white' }}
                >
                  cashewcounty.guhagar@gmail.com
                </Link>
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                <Phone sx={{ color: 'primary.light' }} style={{ color: 'white' }} />
                <Link
                  href="tel:+919049527485"
                  color="white"
                  sx={{
                    textDecoration: 'none',
                    color: 'white',
                    opacity: 0.9,
                    '&:hover': {
                      opacity: 1,
                      color: 'white',
                    },
                  }}
                  style={{ color: 'white' }}
                >
                  +919049527485
                </Link>
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                <Phone sx={{ color: 'primary.light' }} style={{ color: 'white' }}/>
                <Link
                style={{ color: 'white' }}
                  href="tel:+919890047485"
                  color="white"
                  sx={{
                    textDecoration: 'none',
                    color: 'white',
                    opacity: 0.9,
                    '&:hover': {
                      opacity: 1,
                      color: 'white',
                    },
                  }}
                >
                  +919890047485
                </Link>
              </Box>
            </Box>

            {/* Social Media */}
            <Box sx={{ mt: 3 }}>
              <Typography
                variant="h6"
                component="h4"
                gutterBottom
                sx={{ fontWeight: 600, mb: 2 }}
              >
                Follow Us
              </Typography>
              <Box sx={{ display: 'flex', gap: 1 }}>
                {socialLinks.map((social) => (
                  <IconButton
                    key={social.label}
                    href={social.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    sx={{
                      color: 'white',
                      backgroundColor: 'rgba(255, 255, 255, 0.1)',
                      '&:hover': {
                        backgroundColor: 'rgba(255, 255, 255, 0.2)',
                      },
                    }}
                  >
                    {social.icon}
                  </IconButton>
                ))}
              </Box>
            </Box>
          </Grid>
        </Grid>

        <Divider sx={{ my: 4, borderColor: 'rgba(255, 255, 255, 0.2)' }} />

        {/* Bottom Section */}
        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', md: 'row' },
            justifyContent: 'space-between',
            alignItems: 'center',
            gap: 2,
          }}
        >
          <Typography variant="body2" sx={{ opacity: 0.8 }}>
            We use cookies to ensure you get the best experience on our website.
          </Typography>
          <Typography variant="body2" sx={{ opacity: 0.8 }}>
            Cashew County © 2024. All Rights Reserved.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer; 